import {SessionItemData} from '@workflow/services/session-item-data';
import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MissingValueService {
	static isMissingValue(item: {missingValueKey?: string, missingValueKeyGroup?: string}, data: SessionItemData): boolean {
		return (!!item.missingValueKey && !!(data?.getProperty(item.missingValueKey))) || (!!item.missingValueKeyGroup && !!(data?.getProperty(item.missingValueKeyGroup)));
	}
}
